function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaglogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#61C7D2"
    },
    points: "310.429,74.597 86.201,74.597 78.297,365.641 318.333,365.641 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EFEFEF"
    },
    points: "425.801,210.869 201.573,210.869 193.669,501.913 433.705,501.913 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M435.883,210.596c-0.148-5.462-4.618-9.813-10.083-9.813h-54.769v-12.292 c0-27.654-21.613-50.344-48.833-52.096l-1.686-62.072c-0.148-5.462-4.618-9.813-10.083-9.813h-54.77V52.218 C255.658,23.425,232.232,0,203.44,0h-10.252c-28.793,0-52.218,23.425-52.218,52.218V64.51H86.201 c-5.464,0-9.934,4.351-10.083,9.813l-7.905,291.044c-0.074,2.721,0.956,5.357,2.855,7.308c1.899,1.952,4.506,3.052,7.228,3.052 h108.71l-3.419,125.912c-0.074,2.721,0.956,5.357,2.855,7.308c1.9,1.952,4.506,3.052,7.228,3.052h240.036 c2.722,0,5.331-1.101,7.228-3.052c1.899-1.951,2.928-4.587,2.855-7.308L435.883,210.596z M350.857,188.491v12.292h-26.912 l-1.197-44.085C338.566,158.645,350.857,172.156,350.857,188.491z M303.765,200.783h-27.248v-12.292 c0-15.623,11.243-28.664,26.059-31.475L303.765,200.783z M161.144,52.218c0-17.67,14.375-32.045,32.045-32.045h10.252 c17.669,0,32.044,14.375,32.044,32.045V64.51h-74.341L161.144,52.218L161.144,52.218z M191.49,210.596l-2.467,90.846h-45.164 c-5.57,0-10.087,4.516-10.087,10.087c0,5.57,4.516,10.087,10.087,10.087h44.616l-0.922,33.939H88.661l7.357-270.871h44.952v22.918 c0,5.57,4.516,10.087,10.087,10.087s10.087-4.516,10.087-10.087V84.683h74.341v22.918c0,5.57,4.516,10.087,10.087,10.087 s10.087-4.516,10.087-10.087V84.683h44.953l1.412,52.014c-25.716,3.229-45.681,25.217-45.681,51.793v12.292h-54.77 C196.108,200.783,191.637,205.134,191.49,210.596z M204.033,491.827l7.357-270.871h44.953v22.919 c0,5.57,4.516,10.087,10.087,10.087s10.087-4.516,10.087-10.087v-22.919h74.341v22.919c0,5.57,4.516,10.087,10.087,10.087 c5.57,0,10.087-4.516,10.087-10.087v-22.919h44.952l7.358,270.871H204.033z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M371.493,325.726c-3.94-3.938-10.325-3.938-14.265,0l-98.344,98.344 c-3.939,3.94-3.939,10.325,0,14.265c1.971,1.969,4.55,2.954,7.132,2.954s5.163-0.985,7.132-2.954l98.344-98.344 C375.432,336.05,375.432,329.666,371.493,325.726z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M303.84,334.119c0-18.771-15.271-34.042-34.042-34.042s-34.042,15.271-34.042,34.042 s15.271,34.042,34.042,34.042S303.84,352.89,303.84,334.119z M255.928,334.119c0-7.647,6.222-13.869,13.869-13.869 s13.869,6.222,13.869,13.869s-6.222,13.869-13.869,13.869S255.928,341.766,255.928,334.119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M364.359,394.639c-18.771,0-34.042,15.271-34.042,34.042s15.271,34.042,34.042,34.042 s34.042-15.271,34.042-34.042S383.13,394.639,364.359,394.639z M364.359,442.55c-7.647,0-13.869-6.222-13.869-13.869 s6.222-13.869,13.869-13.869s13.869,6.222,13.869,13.869S372.007,442.55,364.359,442.55z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaglogo);
export default __webpack_public_path__ + "static/media/Baglogo.75fbb27999b66e94c512c225541ebb87.svg";
export { ForwardRef as ReactComponent };